/**
 * `randomUuid` — the app's single UUID mint.
 *
 * `crypto.randomUUID()` is **secure-context-only**: it does not exist on
 * `http://<lan-ip>` origins (only `localhost` is exempt), and calling it
 * there threw at boot and blanked the whole app the first time the dev
 * server was opened from a headset browser by IP. `crypto.getRandomValues`
 * has no such restriction, so insecure contexts fall back to a spec-correct
 * RFC 4122 v4 built from it.
 *
 * Output is lowercase in both paths — Campfire ids are lowercase by
 * convention (GUID-nibble sort-key ranges in Dynamo depend on it).
 */
export function randomUuid(): string {
  if (typeof crypto.randomUUID === "function") return crypto.randomUUID();
  const bytes = crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6] & 0x0f) | 0x40; // version 4
  bytes[8] = (bytes[8] & 0x3f) | 0x80; // variant 10xx
  const hex: string[] = [];
  for (const b of bytes) hex.push(b.toString(16).padStart(2, "0"));
  return (
    hex.slice(0, 4).join("") +
    "-" +
    hex.slice(4, 6).join("") +
    "-" +
    hex.slice(6, 8).join("") +
    "-" +
    hex.slice(8, 10).join("") +
    "-" +
    hex.slice(10, 16).join("")
  );
}
